module.exports = __webpack_public_path__ + "static/media/pngIcon.4da5aa31.svg";